<template>
  <div style="height:100%;">
    <div class="pc-only" style="height: 100%;">
      <div style="display:flex;height:100%">
        <div class="pic" :style="{backgroundImage:'url('+basicInfo.backgroundUrl+')'}">
          <div class="pro-title">小文短信服务</div>
          <div class="pro-des">您可以通过“小文聚合短信”自由选购短信网关，支持私有短信网关对接，支持短信标签自定义，变量内容模板管理，支持短信群发，API接口发送</div>
        </div>
        <div class="login-content">
          <div class="login-logo">
            <img :src="basicInfo.logo" alt="">
            <span>{{basicInfo.logoName}}</span>
          </div>
          <img class="colorful" src="../assets/img/colorful.png" alt="">
          <!-- <div @click="ifHaveAccount" class="no-account">没有账号，去注册</div> -->
          <div class="main">
            <div style="color: rgba(0, 0, 0, 1);font-size: 26px;font-weight:bold">
              登录
            </div>
            <div v-if="hasAccount" style="margin-top:20px">
              <div v-if = wechatLogin
                id="formLogin"
                class="user-layout-login"
                ref="formLogin"
              >
                  <div class="login-head">
                    <div class="login-way">
                      <div @click="chooseTab(1)" :class="{'active':currentTab==1}">账号登录</div>
                      <span class="line line1" v-if="currentTab==1"></span>
                    </div>
                  </div>
                  <div style="clear:both"></div>
                  <div style="margin-top:54px">
                    <div v-if="currentTab==1">
                      <div style="margin-bottom:20px">
                        <a-input
                          v-model="accountNumber"
                          size="large"
                          type="text"
                          placeholder="手机号"
                          :max-length="11"
                          @input="loginInputPhone"
                          style="height:52px;background:rgba(188, 202, 214, 0.2);border:none"
                        >
                        </a-input>
                      </div>
                      <div>
                        <a-input
                          v-model="password"
                          size="large"
                          type="password"
                          placeholder="密码"
                          style="margin-bottom:12px;height:52px;background:rgba(188, 202, 214, 0.2);border:none"
                        >
                        </a-input>
                      </div>
                      <!-- <div style="text-align:right;margin-bottom:12px;">
                        <a-checkbox @change="rememberPassword" :default-checked='ifRememberPassword' style="font-size:14px;color:rgba(139, 152, 167, 1)">记住密码</a-checkbox>
                      </div> -->
                    </div>
                  </div>
                  
                <div style="margin-top:12px">
                  <a-button @click="loginIn('pc')"
                    size="large"
                    type="primary"
                    htmlType="submit"
                    class="login-button"
                    style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);font-size:18px;height:52px"
                  >登录</a-button>
                </div>
              </div>
              <div v-if = !wechatLogin class="wechat-login">
                <img src="../assets/img/erweima.png" alt="">
                <div class="wechat-login-text">微信扫码登陆</div>
                <div class="back-login">
                  <span @click="backLogin" style="cursor:pointer">
                    <a-icon type="rollback" />
                    <span>返回</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <div style="position:absolute;bottom:20px;width:100%">
            <div style="font-size:12px;color:rgba(204, 204, 204, 1);text-align:center">
              <a style="color:rgba(204, 204, 204, 1);" target="_blank" href="https://beian.miit.gov.cn/">{{ basicInfo.support }}</a>
            </div>
            <div style="color:rgba(204, 204, 204, 1);font-size:12px;text-align:center">
              <!-- <span style="cursor:pointer" @click="showPicModal('1','全国呼叫中心增值电信业务经营许可证')">全国呼叫中心增值电信业务经营许可证B2-20160586</span> | 
              <span style="cursor:pointer" @click="showPicModal('2','95电信网码号资源许可证')">95电信网码号资源许可证952112</span> |  -->
              <span style="cursor:pointer" @click="showPicModal('3','106短信码号资源许可证')">106短信码号资源许可证10686840</span>
              <!-- <span style="cursor:pointer" @click="showPicModal('4','全国多方通信许可证')">全国多方通信许可证B2-20160586</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-only" style="height: 100%;position: relative;padding:48px 32px 0">
      <img src="../assets/img/colorful.png" style="width:80%;position: absolute;right: 0;top:0;" alt="">
      <div style="">
        <img style="width:36px;float: left;" src="../assets/img/logo.png" alt="">
        <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight: bold;margin-left:12px;float: left;margin-top:4px;">小文短信服务</span>
      </div>
      <div style="clear: both"></div>
      <div style="color:rgba(0, 0, 0, 1);font-size: 26px;font-weight: bold;margin-top:96px;">登录</div>
      <div style="margin-bottom:20px;margin-top:48px;">
        <a-input
          v-model="accountNumber"
          size="large"
          type="text"
          placeholder="请输入手机号"
          :max-length="11"
          @input="loginInputPhone"
          style="height:52px;background:rgba(188, 202, 214, 0.2);border:none"
        >
        </a-input>
      </div>
      <div>
        <a-input
          v-model="password"
          size="large"
          type="password"
          placeholder="请输入密码"
          style="margin-bottom:12px;height:52px;background:rgba(188, 202, 214, 0.2);border:none"
        >
        </a-input>
      </div>
      <div style="margin-top:31px">
        <a-button @click="loginIn('mobile')"
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          style="background:rgba(66, 223, 228, 1);border-color:rgba(66, 223, 228, 1);font-size:18px;height:48px;width: 100%;"
        >登录</a-button>
      </div>
      <div style="color:rgba(179, 184, 193, 1);font-size:13px;text-align: center;position: absolute;left:0;bottom:16px;width: 100%;">106短信号码资源许可证10684254</div>
    </div>
    <a-modal
      :title="picName"
      :visible="showPicVisiable"
      :footer="null"
      width='540px'
      @cancel="offShowPic"
    >
     <img v-if="currentImg==1" style="width:100%" src='~@/assets/img/certificates/pic1.jpg' alt="">
     <img v-if="currentImg==2" style="width:100%" src='~@/assets/img/certificates/pic2.jpg' alt="">
     <img v-if="currentImg==3" style="width:100%" src='~@/assets/img/certificates/pic3.jpg' alt="">
     <img v-if="currentImg==4" style="width:100%" src='~@/assets/img/certificates/pic4.jpg' alt="">
    </a-modal>
  </div>
</template>

<script>
// import CryptoJS from "crypto-js";
export default {
  name: 'Login',
  props: {
    msg: String,
  },
  computed: {
    buttonText() {
      return this.isCounting ? `${this.countdown}秒后重发` : '获取验证码';
    },
  },
  data() {
    return {
      wechatLogin: true,
      currentTab: 1,
      accountNumber: null,
      password: null,
      phoneNum:'',
      verificationCode: null,
      hasAccount: true,
      ifRememberPassword: true,
      title: '登录',
      showPicVisiable: false,
      picName:'',
      currentImg: '',
      basicInfo: '',
      pageTitle: '',
      faviconIcon: '',
      countdown: 60, // 倒计时初始值
      isCounting: false, // 是否在倒计时中
      timer: null, // 定时器
    };
  },
  methods: {
    /*--------是否微信登陆---------*/
    backLogin(){
      this.wechatLogin = !this.wechatLogin
    },
    /*--------是否记住密码---------*/
    rememberPassword(e) {
      this.ifRememberPassword = e.target.checked
    },
    /*--------账号密码登陆&手机验证码登录---------*/
    loginIn (type) {
      if(this.currentTab == 1){
        this.axios.post('api/login/loginByAccount', {
          phone: this.accountNumber,
          password: this.password
        })
        .then(response=> {
          if(response.data.code == 0){
            this.sessionData('set','token',response.data.data.token)
            if(type == 'pc'){
              this.$router.push("/SendRecord")
            }else{
              this.$router.push("/MobileRecord")
            }
          }else{
            this.$message.error(response.data.userTip)
          }
        })
        .catch(error=> {
          console.log(error);
        });
      }
    },
    /*--------获取手机短信验证码---------*/
    getMsg(){
      if(this.phoneNum.length == 11){
        this.startCountdown();
        this.axios.post('/api/verifyCode', {
          phone: this.phoneNum,
          type: '1'
        })
        .then(response=> {
          if(response.data.code == 0){
            this.success('短信发送成功')
          }else{
            this.$message.error(response.data.userTip)
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }else{
        this.$message.error('请输入正确手机号')
      }
    },
    startCountdown() {
      this.isCounting = true;
      this.countdown = 60; // 重置倒计时
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.stopCountdown();
        }
      }, 1000);
    },
    stopCountdown() {
      clearInterval(this.timer);
      this.isCounting = false;
      this.timer = null;
    },
    /*--------切换tab---------*/
    chooseTab(type) {
      this.currentTab = type
    },
    ifHaveAccount() {
      window.open("http://cloud.ixiaowen.net/#/Login?registerValue=true&appId=1", "_self");
    },
    loginInputPhone(e){
      let filtered = e.target.value.replace(/^0|[^\d]/g, '');  
      if(this.accountNumber != filtered){
          this.accountNumber = filtered;
      }
    },
    offShowPic() {
      this.showPicVisiable = false
    },
    showPicModal(path,name) {
      this.showPicVisiable = true
      this.picName = name
      this.currentImg = path
    },
    queryBasicInfo() {
      let host = window.location.host
      console.log(host)
      this.axios(
        {
          method:'get',
          url:'/api/login/loginInfo', 
          params: {
            hostName: host,
          }
      })
      .then(response=> {
        if(response.data.code == 0){
          this.basicInfo = response.data.data
          this.pageTitle = response.data.data.sysName
          this.faviconIcon = response.data.data.titleLogo
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    }
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    this.stopCountdown();
  },
  mounted: function() {
    this.queryBasicInfo()
  },
  updated() {
    document.title = this.pageTitle;
  }
}
</script>

<style lang="less" scoped>
  /* PC */
  @media (min-width: 768px) {
    .pc-only {
      display: block;
    }
    .mobile-only {
      display: none;
    }
  }

  /* Mobile */
  @media (max-width: 767px) {
    .pc-only {
      display: none;
    }
    .mobile-only {
      display: block;
    }
  }

  .ant-form-item{
    margin: 0px !important;
  }
  .user-layout-login {
    label {
      font-size: 14px;
    }
    .get-captcha {
      display: block;
      width: 100%;
      height: 52px;
      border-color: #eee;
      line-height: 50px;
      padding-left: 12px;
      font-size: 14px;
    }
    .forge-password {
      font-size: 14px;
    }
    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
    }
    .user-login-other {
      text-align: center;
      margin-top: 16px;
      font-size: 13px;
      color:rgba(139, 152, 167, 1);
      span{
        cursor: pointer;
      }
    }
  }
  .pic{
    width: 640px;
    height: 100%;
    // background: url('../assets/img/login-bg.jpg');
    padding: 196px 0 0 70px;
    .pro-title{
      color: rgba(18, 18, 18, 1);
      font-size: 40px;
      letter-spacing: 1px;
    }
    .pro-des{
      color: rgba(44, 64, 90, 1);
      font-size: 16px;
      margin-top: 32px;
    }
  }
  .login-content{
    flex: 1;
    position: relative;
    background: #fff;
    .colorful{
      position: absolute;
      right: 0;
      top: 0;
      width: 360px;
    }
    .no-account{
      color:rgba(0, 0, 0, 1);
      font-size: 14px;
      cursor: pointer;
      position: absolute;
      right: 70px;
      top: 34px;
      font-weight: bold;
      font-size: 15px;
    }
    .login-logo{
      position: absolute;
      left: 60px;
      top: 20px;
      img{
        width: 48px;
        float: left;
        margin-right: 8px;
      }
      span{
        color: rgba(0, 0, 0, 1);
        font-size: 20px;
        float: left;
        font-weight: bold;
        margin-top: 8px;
      }
    }
    .main{
      min-width: 260px;
      width: 320px;
      // height: 450px;
      margin: 0 auto 0;
      position: absolute;
      top:50%;
      left:50%;
      margin-top: -260px;
      margin-left:-130px;
      .wechat-login{
        text-align: center;
        img{
          display: block;
          margin: 30px auto 0;
          width: 205px;
        }
        .wechat-login-text{
          margin: 40px auto 8px;
        }
        i{
          margin-right: 5px;
        }
        .backLogin{
          cursor: pointer;
        }
      }
      .login-head{
        .login-way{
          display: inline-block;
          margin-right: 32px;
          color: rgba(0, 0, 0, 1);
          font-size: 18px;
          cursor: pointer;
          text-align: center;
          position: relative;
          text-align: center;
          // float: left;
        }
        div.active{
          color: #22D7BB;
        }
        .line{
          display: inline-block;
          width: 32px;
          height: 4px;
          background: rgba(34, 215, 187, 1);
          text-align: center;
          float: left;
          margin-top: 4px;
          position: absolute;
          left: 50%;
        }
        .line1{
          margin-left: -16px;
        }
        .line2{
          margin-left: -16px;
        }
      }
    }
  }
  .ant-input:focus {
    border: none;
    box-shadow: none;
  }
</style>
